import Post, {IPost} from '@/models/Post'
import { KeyPair } from '@/types/KeyPair'

export interface IAdvice extends IPost {
  client: string
  advisor: string
  question: string
  answer: string
  illustrator: string
}

export default class Advice extends Post {
  client = ''
  advisor = ''
  question = ''
  answer = ''
  illustrator = ''
  constructor(defaults?: IAdvice) {
    super(defaults)
    if (defaults) {
      this.client = defaults.client || 'man'
      this.advisor = defaults.advisor || 'kamata'
      this.question = defaults.question
      this.answer = defaults.answer
      this.illustrator = defaults.illustrator
    }
  }

  get contentEscapeHtml(): string {
    const c = this.question + ''
    return c.replace(/<("[^"]*"|'[^']*'|[^'">])*>/g,'')
  }

  get className(): string {
    return Advice.name
  }

  toParams(): KeyPair {
    return Object.assign({}, super.toParams(), {
      client: this.client,
      advisor: this.advisor,
      question: this.question,
      answer: this.answer,
      illustrator: this.illustrator
    })
  }
}
